export const meta = {
  slug: { de: "facharzt-termin-wartezeit-verkuerzen", en: "specialist-appointment-shorter-wait" },
  title: "Facharzttermin: wie sich Wartezeiten realistisch verkürzen lassen",
  excerpt:
    "Lange Wartezeiten beim Facharzt haben strukturelle Gründe. Es gibt aber konkrete Wege, an denen Patienten und Praxen gleichermaßen ansetzen können.",
  category: "einblicke",
  publishedAt: "2026-04-16",
  metaTitle: "Facharzttermin Wartezeit verkürzen | OnePractix",
  metaDescription:
    "Warum Facharzttermine so lange dauern und welche Wege Patienten und Praxen nutzen können, um Wartezeiten realistisch zu verkürzen.",
  related: ["online-arzttermin-vorteile-nachteile", "orthopaede-termin-schnell"],
  en: {
    title: "Specialist appointment: how waiting times can be realistically shortened",
    metaTitle: "Specialist appointment waiting times | OnePractix",
    metaDescription:
      "Why specialist appointments take so long and which paths patients and practices can use to realistically shorten waiting times.",
    excerpt:
      "Long waiting times for a specialist have structural reasons. But there are concrete paths that both patients and practices can take.",
  },
};

export default meta;
